module.exports = __webpack_public_path__ + "img/arrowBackIcon.cb6c6f59.svg";